module.exports = __webpack_public_path__ + "account/assets/oops-rhino-draws.38d229d8.svg";